module.exports = __webpack_public_path__ + "img/Bleck_bild.bd7e4724.jpg";